export default __webpack_public_path__ + "static/media/gallery-wip-neck-grenade_07.ac886155.jpg";